module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('em', [_vm._v("Preface to Volume 4")])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("This is the fourth of five volumes that collect my writings on religious liberty. Volume 1, "), _c('em', [_vm._v("Overviews and History")]), _vm._v(", was principally devoted to articles that survey the field and articles on the history of religious liberty in the United States. Volume 2, "), _c('em', [_vm._v("The Free Exercise Clause")]), _vm._v(", addressed constitutional litigation to protect the free exercise of religion under the federal Constitution. Volume 3, "), _c('em', [_vm._v("Religious Freedom Restoration Acts, Same-Sex Marriage Legislation, and the Culture Wars")]), _vm._v(", addressed state and federal RFRAs, religious-liberty provisions in state marriage legislation, and litigation over religious liberty with respect to contraception and marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This volume picks up where volume 3 left off, addressing three congressional efforts from the late 1990s. Two of these bills were enacted: the Religious Land Use and Institutionalized Persons Act (RLUIPA) and the Religious Liberty and Charitable Donation Protection Act. One was not: the proposed Religious Liberty Protection Act (RLPA).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The RLPA debate was a critically important episode; it was the point at which religious liberty became a culture-wars issue. The intense opposition to RLPA, the persistent resistance to implementation of RLUIPA, and the bitter and unprecedented litigation that made the Donation Act necessary all illustrate the extent to which religious liberty has become deeply controversial in our time. This volume examines the legislative battles over these bills and the litigation about the two laws that were enacted, and it collects my writings on the larger policy debate over religious exemptions in the context of the culture wars.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("Volume 5, "), _c('em', [_vm._v("The Free Speech and Establishment Clauses")]), _vm._v(", will address religious free speech, government speech about religion, government funding for religious institutions, and other Establishment Clause issues. The entire project is ")]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("more fully described in the Preface to the Collected Works, in volume 1, except that when that was written, what are now volumes 3 and 4 were envisioned as a single volume 3.")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This volume contains traditional scholarly articles, popular commentary, briefs and arguments to courts, and letters and testimony to legislators and legislative committees. The legislative documents form a documentary history—from my point of view of course—of the efforts to enact these laws. As in volume 3, there is a narrative to most sections in this volume, as bills move through the legislative process, sometimes encountering opposition from both left and right, in an increasingly polarized environment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Editorial conventions have been carried forward from earlier volumes. Legal citation form is explained in Appendix II to volume 1. I am grateful to Jonathan Amgott and James Hasson for help in preparing the manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUGLAS")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AYCOCK")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("Charlottesville")])]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('em', [_vm._v("July 2018")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e605d7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Preface.vue
// module id = 75
// module chunks = 0